import React, { useEffect } from "react";
import CalendarItem from "./calendar-item";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getExpirationDates } from "../../../../Redux/actions/credit-line";
import { getExpirationsDates as getReducerExpirationsDates } from "../../../../Redux/reducer/credit-line";

import SimpleBar from "simplebar-react";

const CalendarEvents = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const expirations = useSelector((state) => getReducerExpirationsDates(state));

  useEffect(() => {
    async function fetchBills() {
      return await dispatch(getExpirationDates());
    }

    fetchBills();
  }, []);

  return (
    <div className={`calendar-container ${props.className}`}>
      <h3>{t("dashboard.expiration.title")}</h3>
      <div className="calendar-dates">
        <SimpleBar forceVisible="y" style={{ maxHeight: 350, width: "100%" }}>
          {expirations.map((itemCalendar, idx) => (
            <CalendarItem
              key={`calendar-item-${idx}`}
              itemCalendar={itemCalendar}
            />
          ))}
        </SimpleBar>
      </div>
    </div>
  );
};

export default CalendarEvents;
